@if (safeUrl) {
	<iframe
		[src]="safeUrl"
		allow="
			microphone *;
			encrypted-media *;
			fullscreen *;
			speaker-selection *;
			unsized-media *;
			camera *;
			display-capture *;
			clipboard-write *;
			clipboard-read *;
		"
		#iframe
	></iframe>
}
